<div class="sidebar-filters-content collapse-icon">
  <div class="collapse-default">
    <div class="card">
      <div class="card-header">
        <button class="row collapse-title btn pl-0 pr-0 pt-0 pb-0"
                (click)="isCollapsed = !isCollapsed"
                [attr.aria-expanded]="!isCollapsed"
                aria-controls="collapseExample"
                data-toggle="collapse"
                role="button">
          <h6>{{ 'CASHBACK.LIST_PAGE.CATEGORIES' | translate }}</h6>
        </button>
      </div>

      <div [ngbCollapse]="isCollapsed" id="collapseExample">
        <div class="card">
          <div class="card-body">
            <div class="categories-list">
              <div *ngFor="let category of categories" class="category-item">
                <div class="filter-check">
                  <div class="custom-control custom-checkbox">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      [(ngModel)]="categoriesSelection[category]"
                      [id]="'category-' + category"
                      (change)="checkCategory()"
                    />
                    <label class="custom-control-label" [for]="'category-' + category"></label>
                  </div>
                  <label [for]="'category-' + category" class="filter-details">
                    <div class="title">
                      {{ ('CASHBACK.LIST_PAGE.CATEGORY_LABELS.' + category | translate) || category }}
                    </div>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
